export default __webpack_public_path__ + "static/media/bullet.e0aae03f.svg";